// Text Key
export const TXT_LOGIN = "TXT_LOGIN";
export const TXT_CHANGE_INFO = "TXT_CHANGE_INFO";
export const TXT_ADD_AVATAR = "TXT_ADD_AVATAR";
export const TXT_COMPANY_PROFILE = "TXT_COMPANY_PROFILE";
export const TXT_APP_COPYRIGHT = "TXT_APP_COPYRIGHT";
export const TXT_INVITE_AGAIN = "TXT_INVITE_AGAIN";
export const TXT_INVITED = "TXT_INVITED";
export const TXT_CONFIRM_REMOVE_USER_HEADING = "TXT_CONFIRM_REMOVE_USER_HEADING";
export const TXT_ADD_NEW_USER = "TXT_ADD_NEW_USER";
export const TXT_EXPORT_USER_LIST = "TXT_EXPORT_USER_LIST";
export const TXT_ENTER_NEW_PASSWORD = "TXT_ENTER_NEW_PASSWORD";
export const TXT_SELECTED_USER = "TXT_SELECTED_USER";
export const TXT_CONTACT_FOUND = "TXT_CONTACT_FOUND";
export const TXT_NOT_FOUND = "TXT_NOT_FOUND";
export const TXT_LOADING = "TXT_LOADING";
export const TXT_SERVER_EXPIRED = "TXT_SERVER_EXPIRED";
export const TXT_SERVER_ACTIVE = "TXT_SERVER_ACTIVE";
export const TXT_UPGRADE_LICENSE_PHONE_NUM = "TXT_UPGRADE_LICENSE_PHONE_NUM";
export const TXT_UPDATE_PASSWORD_SUCCESS = "TXT_UPDATE_PASSWORD_SUCCESS";
export const TXT_CHANGE_PASSWORD = "TXT_CHANGE_PASSWORD";
export const TXT_CHANGE_PASSWORD_TITLE = "TXT_CHANGE_PASSWORD_TITLE";
export const TXT_INFORMATION = "TXT_INFORMATION";
export const TXT_EDIT_INFO = "TXT_EDIT_INFO";
export const TXT_RESET_PASSWORD = "TXT_RESET_PASSWORD";
export const TXT_DETAILS_INFO = "TXT_DETAILS_INFO";
export const TXT_EDIT_USER_INFO = "TXT_EDIT_USER_INFO";
export const TXT_MODE = "TXT_MODE";
export const TXT_BRANCH_MODE = "TXT_BRANCH_MODE";
export const TXT_LOGIN_MODE = "TXT_LOGIN_MODE";
export const TXT_NOTIFICATION_ERROR_TITLE = "TXT_NOTIFICATION_ERROR_TITLE";
export const TXT_NOTIFICATION_ERROR_CONTENT = "TXT_NOTIFICATION_ERROR_CONTENT";
export const TXT_CONFIRM_ACTIVE_USER = "TXT_CONFIRM_ACTIVE_USER";
export const TXT_UPDATE_ERROR = "TXT_UPDATE_ERROR";
export const TXT_EMAIL_WRONG = "TXT_EMAIL_WRONG";
export const TXT_UPDATE_SUCCESS = "TXT_UPDATE_SUCCESS";
export const TXT_DELETE_FAIL = "TXT_DELETE_FAIL";
export const TXT_CONFIRM_DELETE_BRANCH = "TXT_CONFIRM_DELETE_BRANCH";
export const TXT_ADD_BRANCH = "TXT_ADD_BRANCH";
export const TXT_ACTIVE_ERROR = "TXT_ACTIVE_ERROR";
export const TXT_INACTIVE_ERROR = "TXT_INACTIVE_ERROR";
export const TXT_INVALID_DATE = "TXT_INVALID_DATE";
export const TXT_DATE_NULL = "TXT_DATE_NULL";
export const TXT_UPLOAD_DUPLICATE_DATA = "TXT_UPLOAD_DUPLICATE_DATA";
export const TXT_UPLOAD_MAX_USER_WRONG = "TXT_UPLOAD_MAX_USER_WRONG";
export const TXT_CONFIRM_CANCEL_CREATE_BRANCH = "TXT_CONFIRM_CANCEL_CREATE_BRANCH";
export const TXT_OF = "TXT_OF";
export const TXT_MORE_THAN = "TXT_MORE_THAN";
export const TXT_FAILURE_VALIDATION = "TXT_FAILURE_VALIDATION";
export const TXT_ADD_USER_SUCCESS = "TXT_ADD_USER_SUCCESS";
export const TXT_CHANGE_SMS_OTP = "TXT_CHANGE_SMS_OTP";
export const TXT_CHANGE_SMART_OTP = "TXT_CHANGE_SMART_OTP";
export const TXT_RESEND_OTP = "TXT_RESEND_OTP";
export const TXT_CHANGE_PHONE_NUMBER = "TXT_CHANGE_PHONE_NUMBER";
export const TXT_SYSTEM_ERROR_LIST = "TXT_SYSTEM_ERROR_LIST";
export const TXT_USER_ACTIVITY_LIST = "TXT_USER_ACTIVITY_LIST";
export const TXT_VERIFY_SMART_OTP_CONTENT = "TXT_VERIFY_SMART_OTP_CONTENT";
export const TXT_VERIFY_OTP = "TXT_VERIFY_OTP";
export const TXT_SMART_OTP_RETRY = "TXT_SMART_OTP_RETRY";
export const TXT_SMART_OTP_BLOCK = "TXT_SMART_OTP_BLOCK";
export const TXT_SMART_OTP_EXPIRED = "TXT_SMART_OTP_EXPIRED";
export const TXT_SMART_OTP_LIMIT_ERROR = "TXT_SMART_OTP_LIMIT_ERROR";
export const TXT_GRANT_ADMIN_PERMISSION = "TXT_GRANT_ADMIN_PERMISSION";
export const TXT_GRANT_ADMIN_PERMISSION_TITLE = "TXT_GRANT_ADMIN_PERMISSION_TITLE";
export const TXT_REMOVE_ADMIN_PERMISSION = "TXT_REMOVE_ADMIN_PERMISSION";
export const TXT_REMOVE_ADMIN_PERMISSION_TITLE = "TXT_REMOVE_ADMIN_PERMISSION_TITLE";
export const TXT_GENERATE_NEW_ADMIN_PASSWORD = "TXT_GENERATE_NEW_ADMIN_PASSWORD";
export const TXT_GENERATE_NEW_ADMIN_PASSWORD_TEXT = "TXT_GENERATE_NEW_ADMIN_PASSWORD_TEXT";
export const TXT_NEW_ADMIN_PASSWORD = "TXT_NEW_ADMIN_PASSWORD";
export const TXT_CONFIRM_ACTION = "TXT_CONFIRM_ACTION";
export const TXT_LOGIN_EXPIRED = "TXT_LOGIN_EXPIRED";
export const TXT_TITLE_UNIT_LIST = "TXT_TITLE_UNIT_LIST";
export const TXT_CREATE_DEPARTMENT = "TXT_CREATE_DEPARTMENT";
export const TXT_MEMBER_MANAGEMENT = "TXT_MEMBER_MANAGEMENT";
export const TXT_CREATE_CHANNEL = "TXT_CREATE_CHANNEL";
export const TXT_DELETE = "TXT_DELETE";
export const TXT_CREATE_UNIT = "TXT_CREATE_UNIT";
export const TXT_EDIT_UNIT = "TXT_EDIT_UNIT";
export const TXT_ENTER_UNIT_NAME = "TXT_ENTER_UNIT_NAME";
export const TXT_ENTER_DEPARTMENT_NAME = "TXT_ENTER_DEPARTMENT_NAME";
export const TXT_CREATE_DEPARTMENT_TITLE = "TXT_CREATE_DEPARTMENT_TITLE";
export const TXT_EDIT_DEPARTMENT = "TXT_EDIT_DEPARTMENT";
export const TXT_CONFIRM_DELETE_UNIT = "TXT_CONFIRM_DELETE_UNIT";
export const TXT_CONFIRM_DELETE_DEPARTMENT = "TXT_CONFIRM_DELETE_DEPARTMENT";
export const TXT_MEMBER_LIST = "TXT_MEMBER_LIST";
export const TXT_ADD_MEMBER = "TXT_ADD_MEMBER";
export const TXT_CREATE_POSITION_SUCCESS = "TXT_CREATE_POSITION_SUCCESS";
export const TXT_UPDATE_POSITION_SUCCESS = "TXT_UPDATE_POSITION_SUCCESS";
export const TXT_DELETE_POSITION_SUCCESS = "TXT_DELETE_POSITION_SUCCESS";
export const TXT_CONFIRM_DELETE_POSITION = "TXT_CONFIRM_DELETE_POSITION";
export const TXT_ADD_MEMBER_DIALOG = "TXT_ADD_MEMBER_DIALOG";
export const TXT_CONFIRM_DELETE_MEMBER = "TXT_CONFIRM_DELETE_MEMBER";
export const TXT_CONFIRM_DELETE_MEMBER_TITLE = "TXT_CONFIRM_DELETE_MEMBER_TITLE";
export const TXT_CONFIRM_DELETE_MEMBER_TEXT = "TXT_CONFIRM_DELETE_MEMBER_TEXT";
export const TXT_CREATE_CHANNEL_SUCCESS = "TXT_CREATE_CHANNEL_SUCCESS";
export const TXT_CREATE_CHANNEL_FAIL = "TXT_CREATE_CHANNEL_FAIL";
export const TXT_CHANNEL_DUPLICATED = "TXT_CHANNEL_DUPLICATED";
export const TXT_ADD_MEMBER_SUCCESS = "TXT_ADD_MEMBER_SUCCESS";
export const TXT_DELETE_MEMBER_SUCCESS = "TXT_DELETE_MEMBER_SUCCESS";
export const TXT_PHONE_DUPLICATED = "TXT_PHONE_DUPLICATED";
export const TXT_DATA_WRONG_FORMAT = "TXT_DATA_WRONG_FORMAT";
export const TXT_CREATE_ACCOUNT_FAIL = "TXT_CREATE_ACCOUNT_FAIL";
export const TXT_CREATE_ACCOUNT_SUCCESS = "TXT_CREATE_ACCOUNT_SUCCESS";
export const TXT_INVITE_FAIL = "TXT_INVITE_FAIL";
export const TXT_INVITE_SUCCESS = "TXT_INVITE_SUCCESS";
export const TXT_UPDATE_ROLE_ACCOUNT_SUCCESS = "TXT_UPDATE_ROLE_ACCOUNT_SUCCESS";
export const TXT_UPDATE_CONFERENCE_SUCCESS = "TXT_UPDATE_CONFERENCE_SUCCESS";
export const TXT_VIEW_DETAIL = "TXT_VIEW_DETAIL";
export const TXT_DELETE_ADMIN = "TXT_DELETE_ADMIN";
export const TXT_ADD_ADMIN = "TXT_ADD_ADMIN";
export const TXT_CONFIRM_DELETE_ADMIN_TITLE = "TXT_CONFIRM_DELETE_ADMIN_TITLE";
export const TXT_CONFIRM_DELETE_ADMIN_TEXT = "TXT_CONFIRM_DELETE_ADMIN_TEXT";

// Keys used in multiple components
export const TXT_USER = "TXT_USER";
export const TXT_UNIT = "TXT_UNIT";
export const TXT_DEPARTMENT = "TXT_DEPARTMENT";
export const TXT_POSITION = "TXT_POSITION";
export const TXT_STATUS = "TXT_STATUS";

// Channel management
export const TXT_PRIVATE_CHANNEL = "TXT_PRIVATE_CHANNEL";
export const TXT_PUBLIC_CHANNEL = "TXT_PUBLIC_CHANNEL";
export const FM_TOTAL_CHANNELS = "FM_TOTAL_CHANNELS";
export const FM_TOTAL_GROUPS = "FM_TOTAL_GROUPS";
export const FM_TOTAL_MEMBERS_IN_GROUP = "FM_TOTAL_MEMBERS_IN_GROUP";
export const TXT_CHANNEL_SIZE_ALL = "TXT_CHANNEL_SIZE_ALL";
export const TXT_CHANNEL_SIZE_SMALL = "TXT_CHANNEL_SIZE_SMALL";
export const TXT_CHANNEL_SIZE_MEDIUM = "TXT_CHANNEL_SIZE_MEDIUM";
export const TXT_CHANNEL_SIZE_LARGE = "TXT_CHANNEL_SIZE_LARGE";
export const TXT_CHANNEL_SIZE_VERY_LARGE = "TXT_CHANNEL_SIZE_VERY_LARGE";
export const TXT_CHANNEL_SIZE_FILTER = "TXT_CHANNEL_SIZE_FILTER";
export const TXT_GROUP_TYPE_FILTER = "TXT_GROUP_TYPE_FILTER";
export const TXT_DISSOLVE_GROUP = "TXT_DISSOLVE_GROUP";
export const TXT_GRANT_GROUP_ADMIN_BTN = "TXT_GRANT_GROUP_ADMIN_BTN";
export const TXT_REVOKE_GROUP_ADMIN_BTN = "TXT_REVOKE_GROUP_ADMIN_BTN";
export const TXT_REVOKE_GROUP_ADMIN_DISABLED = "TXT_REVOKE_GROUP_ADMIN_DISABLED";
export const TXT_REMOVE_GROUP_MEMBER_BTN = "TXT_REMOVE_GROUP_MEMBER_BTN";
export const TXT_REMOVE_GROUP_MEMBER_DISABLED_MIN = "TXT_REMOVE_GROUP_MEMBER_DISABLED_MIN";
export const TXT_ADD_GROUP_MEMBER = "TXT_ADD_GROUP_MEMBER";

// DHD
export const TXT_COPY_PASSWORD_TITLE = "TXT_COPY_PASSWORD_TITLE";
export const TXT_UPDATE_PASSWORD = "TXT_UPDATE_PASSWORD";
export const TXT_COPY_PASSWORD = "TXT_COPY_PASSWORD";
export const TXT_COPY_ACTION = "TXT_COPY_ACTION";
export const TXT_COPY_SUCCESS = "TXT_COPY_SUCCESS";
export const TXT_COPY_FAILED = "TXT_COPY_FAILED";

// Label Key
export const L_USERNAME = "L_USERNAME";
export const L_PASSWORD = "L_PASSWORD";
export const L_REMEMBER_ME = "L_REMEMBER_ME";
export const L_LOGIN_BUTTON = "L_LOGIN_BUTTON";
export const L_NEW_PASSWORD = "L_NEW_PASSWORD";
export const L_NEW_PASSWORD_CONFIRMATION = "L_NEW_PASSWORD_CONFIRMATION";
export const L_CONTINUE_BUTTON = "L_CONTINUE_BUTTON";
export const L_NEED_HELP_BUTTON = "L_NEED_HELP_BUTTON";
export const L_COMPANY_NAME = "L_COMPANY_NAME";
export const L_COMPANY_AVATAR = "L_COMPANY_AVATAR";
export const L_CHANGE_COMPANY_AVATAR_BUTTON = "L_CHANGE_COMPANY_AVATAR_BUTTON";
export const L_CONFIRM_BUTTON = "L_CONFIRM_BUTTON";
export const L_DISCARD_BUTTON = "L_DISCARD_BUTTON";
export const L_DELETE_USER_BUTTON = "L_DELETE_USER_BUTTON";
export const L_ADD_NEW_USER_BUTTON = "L_ADD_NEW_USER_BUTTON";
export const L_JOINED_STATUS = "L_JOINED_STATUS";
export const L_PENDING_STATUS = "L_PENDING_STATUS";
export const L_REFUSED_STATUS = "L_REFUSED_STATUS";
export const L_ACTIVE_FUNCTION = "L_ACTIVE_FUNCTION";
export const L_FN_DISABLED = "L_FN_DISABLED";
export const L_FN_LOGGED_IN = "L_FN_LOGGED_IN";
export const L_FN_NOT_LOGGED_IN = "L_FN_NOT_LOGGED_IN";
export const L_FN_SUSPENDED = "L_FN_SUSPENDED";
export const L_REMOVE_BUTTON = "L_REMOVE_BUTTON";
export const L_CANCEL_BUTTON = "L_CANCEL_BUTTON";
export const L_ADD_BUTTON = "L_ADD_BUTTON";
export const L_ACTIVE = "L_ACTIVE";
export const L_ACTIVATION_STATE = "L_ACTIVATION_STATE";
export const L_EXPIRED = "L_EXPIRED";
export const L_UPGRADE_LICENSE = "L_UPGRADE_LICENSE";
export const L_PASSWORD_LAST_UPDATE = "L_PASSWORD_LAST_UPDATE";
export const L_OLD_PASSWORD = "L_OLD_PASSWORD";
export const L_UPDATE_PASSWORD_BUTTON = "L_UPDATE_PASSWORD_BUTTON";
export const L_VIETNAMESE_LANGUAGE = "L_VIETNAMESE_LANGUAGE";
export const L_ENGLISH_LANGUAGE = "L_ENGLISH_LANGUAGE";
export const L_LANGUAGE = "L_LANGUAGE";
export const L_SAVE_BUTTON = "L_SAVE_BUTTON";
export const L_PUBLIC_MODE = "L_PUBLIC_MODE";
export const L_PRIVATE_MODE = "L_PRIVATE_MODE";
export const L_PASSWORD_MODE = "L_PASSWORD_MODE";
export const L_OTP_MODE = "L_OTP_MODE";
export const L_ACTIVE_USER = "L_ACTIVE_USER";
export const L_INACTIVE_USER = "L_INACTIVE_USER";
export const L_BRANCH_LIST = "L_BRANCH_LIST";
export const L_OK = "L_OK";
export const L_CREATE = "L_CREATE";
export const L_SWITCH_BRANCH = "L_SWITCH_BRANCH";
export const L_ACTIVE_ACTION = "L_ACTIVE_ACTION";
export const L_INACTIVE_ACTION = "L_INACTIVE_ACTION";
export const L_UPDATE = "L_UPDATE";
export const L_AGREE = "L_AGREE";
export const L_SAVE_INFO = "L_SAVE_INFO";
export const L_CANCEL_ADD_BRANCH = "L_CANCEL_ADD_BRANCH";
export const L_ADD_UNIT_BUTTON = "L_ADD_UNIT_BUTTON";
export const L_CANCEL = "L_CANCEL";
export const L_ALL = "L_ALL";
export const L_CLOSE = "L_CLOSE";
export const L_SELECT_UNIT = "L_SELECT_UNIT";

// Placeholder
export const P_USERNAME = "P_USERNAME";
export const P_PASSWORD = "P_PASSWORD";
export const P_NEW_PASSWORD = "P_NEW_PASSWORD";
export const P_COMPANY_NAME = "P_COMPANY_NAME";
export const P_ADD_NEW_USER = "P_ADD_NEW_USER";
export const P_OLD_PASSWORD = "P_OLD_PASSWORD";
export const P_SEARCH = "P_SEARCH";
export const P_SEARCH_UNIT = "P_SEARCH_UNIT";
export const P_SEARCH_USER_BY_NAME_PHONE_EMAIL = "P_SEARCH_USER_BY_NAME_PHONE_EMAIL";
export const P_SEARCH_USER_BY_NAME_EMAIL = "P_SEARCH_USER_BY_NAME_EMAIL";
export const P_SEARCH_USER_BY_NAME_PHONE = "P_SEARCH_USER_BY_NAME_PHONE";

// Error
export const ERR_OBJECT = "ERR_OBJECT";

// Object
export const OBJ_ROUTER_TITLE = "OBJ_ROUTER_TITLE";
export const OBJ_SIDEBAR_TITLE = "OBJ_SIDEBAR_TITLE";
export const OBJ_ERROR_MSG = "OBJ_ERROR_MSG";
export const OBJ_USER_DETAIL = "OBJ_USER_DETAIL";
export const OBJ_BRANCH_ERROR = "OBJ_BRANCH_ERROR";
export const OBJ_TABLE_ERROR = "OBJ_TABLE_ERROR";
export const OBJ_TABLE_BRANCH = "OBJ_TABLE_BRANCH";
export const OBJ_CONFIRM_RESET = "OBJ_CONFIRM_RESET";
export const OBJ_BRANCH_ERROR_TYPE = "OBJ_BRANCH_ERROR_TYPE";
export const OBJ_TABLE_USER_ACTIVITIES = "OBJ_TABLE_USER_ACTIVITIES";
export const OBJ_USER_ACTIVITIES = "OBJ_USER_ACTIVITIES";
export const OBJ_RANDOM_ADMIN_PASSWORD = "OBJ_RANDOM_ADMIN_PASSWORD";
export const OBJ_UNIT_LIST_TABLE = "OBJ_UNIT_LIST_TABLE";
export const OBJ_UNIT_DETAIL = "OBJ_UNIT_DETAIL";
export const OBJ_UNIT_ERROR = "OBJ_UNIT_ERROR";
export const OBJ_DEPARTMENT_DETAIL = "OBJ_DEPARTMENT_DETAIL";
export const OBJ_DEPARTMENT_ERROR = "OBJ_DEPARTMENT_ERROR";
export const OBJ_CHANNEL_DIALOG = "OBJ_CHANNEL_DIALOG";
export const OBJ_CREATE_CHANNEL_DIALOG = "OBJ_CREATE_CHANNEL_DIALOG";
export const OBJ_POSITION_ERROR = "OBJ_POSITION_ERROR";

// Channel Management Table
export const OBJ_CHANNEL_LIST_TABLE = "OBJ_CHANNEL_LIST_TABLE";
export const OBJ_CONFERENCE_ERROR = "OBJ_CONFERENCE_ERROR";
export const OBJ_ROLE_ACCOUNT_ERROR = "OBJ_ROLE_ACCOUNT_ERROR";

// Channel Management - Update Dialog
export const OBJ_UPDATE_CHANNEL_DIALOG = "OBJ_UPDATE_CHANNEL_DIALOG";

// Channel Management - Add Member Dialog
export const OBJ_ADD_CHANNEL_MEMBER_DIALOG = "OBJ_ADD_CHANNEL_MEMBER_DIALOG";

// Format
export const FM_REMOVE_SINGLE_PERSON = "FM_REMOVE_SINGLE_PERSON";
export const FM_REMOVE_MULTIPLE_PEOPLE = "FM_REMOVE_MULTIPLE_PEOPLE";
export const FM_ACTIVE_SINGLE_PERSON = "FM_ACTIVE_SINGLE_PERSON";
export const FM_ACTIVE_MULTIPLE_PERSON = "FM_ACTIVE_MULTIPLE_PERSON";
export const FM_UPLOAD_PHONE_FORMAT_WRONG = "FM_UPLOAD_PHONE_FORMAT_WRONG";
export const FM_COUNTDOWN_OTP = "FM_COUNTDOWN_OTP";

// Statistic
export const TXT_STATISTIC_USER_OVERVIEW = "TXT_STATISTIC_USER_OVERVIEW";
export const TXT_STATISTIC_MESSAGE_OVERVIEW = "TXT_STATISTIC_MESSAGE_OVERVIEW";
export const TXT_STATISTIC_CALL_OVERVIEW = "TXT_STATISTIC_CALL_OVERVIEW";
export const TXT_STATISTIC_GROUP_OVERVIEW = "TXT_STATISTIC_GROUP_OVERVIEW";
export const TXT_STATISTIC_EXPORT = "TXT_STATISTIC_EXPORT";
export const TXT_STATISTIC_DATA_UPDATED_AT = "TXT_STATISTIC_DATA_UPDATED_AT";
export const TXT_STATISTIC_USER_COUNT_IN = "TXT_STATISTIC_USER_COUNT_IN";
export const TXT_STATISTIC_USER_STATUS = "TXT_STATISTIC_USER_STATUS";
export const TXT_STATISTIC_TOTAL_USERS = "TXT_STATISTIC_TOTAL_USERS";
export const TXT_STATISTIC_TOTAL_UNITS = "TXT_STATISTIC_TOTAL_UNITS";
export const TXT_STATISTIC_TOTAL_DEPARTMENTS = "TXT_STATISTIC_TOTAL_DEPARTMENTS";
export const TXT_STATISTIC_JOINED = "TXT_STATISTIC_JOINED";
export const TXT_STATISTIC_NOT_JOINED = "TXT_STATISTIC_NOT_JOINED";
// 4 trạng thái "Chức năng hoạt động" dùng cho biểu đồ Thống kê
export const TXT_STATISTIC_FN_DISABLED = "TXT_STATISTIC_FN_DISABLED";
export const TXT_STATISTIC_FN_LOGGED_IN = "TXT_STATISTIC_FN_LOGGED_IN";
export const TXT_STATISTIC_FN_NOT_LOGGED_IN = "TXT_STATISTIC_FN_NOT_LOGGED_IN";
export const TXT_STATISTIC_FN_SUSPENDED = "TXT_STATISTIC_FN_SUSPENDED";
export const TXT_STATISTIC_TOTAL_MESSAGES_SENT = "TXT_STATISTIC_TOTAL_MESSAGES_SENT";
export const TXT_STATISTIC_MESSAGES_UNIT = "TXT_STATISTIC_MESSAGES_UNIT";
export const TXT_STATISTIC_NUM_MESSAGES = "TXT_STATISTIC_NUM_MESSAGES";
export const TXT_STATISTIC_TOTAL_CALLS_MADE = "TXT_STATISTIC_TOTAL_CALLS_MADE";
export const TXT_STATISTIC_CALLS_UNIT = "TXT_STATISTIC_CALLS_UNIT";
export const TXT_STATISTIC_NUM_CALLS = "TXT_STATISTIC_NUM_CALLS";
export const TXT_STATISTIC_CALL_STATUS_RATIO = "TXT_STATISTIC_CALL_STATUS_RATIO";
export const TXT_STATISTIC_CALL_SUCCESS = "TXT_STATISTIC_CALL_SUCCESS";
export const TXT_STATISTIC_CALL_MISSED = "TXT_STATISTIC_CALL_MISSED";
export const TXT_STATISTIC_CALL_CANCELED = "TXT_STATISTIC_CALL_CANCELED";
export const TXT_STATISTIC_TOTAL_CALLS = "TXT_STATISTIC_TOTAL_CALLS";
export const TXT_STATISTIC_USER_LIST_IN = "TXT_STATISTIC_USER_LIST_IN";
export const TXT_STATISTIC_USER_COUNT_TITLE_IN = "TXT_STATISTIC_USER_COUNT_TITLE_IN";
export const TXT_STATISTIC_JOINED_USER_LIST = "TXT_STATISTIC_JOINED_USER_LIST";
export const TXT_STATISTIC_JOINED_USER_COUNT = "TXT_STATISTIC_JOINED_USER_COUNT";
export const TXT_STATISTIC_NOT_JOINED_USER_LIST = "TXT_STATISTIC_NOT_JOINED_USER_LIST";
export const TXT_STATISTIC_NOT_JOINED_USER_COUNT = "TXT_STATISTIC_NOT_JOINED_USER_COUNT";
export const TXT_STATISTIC_PEOPLE_UNIT = "TXT_STATISTIC_PEOPLE_UNIT";

// Executive Summary Cards
export const TXT_CARD_TOTAL_USERS = "TXT_CARD_TOTAL_USERS";
export const TXT_CARD_ALL_ACCOUNTS = "TXT_CARD_ALL_ACCOUNTS";
export const TXT_CARD_JOINED = "TXT_CARD_JOINED";
export const TXT_CARD_PENDING = "TXT_CARD_PENDING";
export const TXT_CARD_DISABLED = "TXT_CARD_DISABLED";
export const TXT_CARD_SUSPENDED = "TXT_CARD_SUSPENDED";
export const TXT_CARD_ONLINE_USERS = "TXT_CARD_ONLINE_USERS";
export const TXT_CARD_DETAILS = "TXT_CARD_DETAILS";
export const TXT_CARD_CONNECTED_APP = "TXT_CARD_CONNECTED_APP";
export const TXT_CARD_REALTIME_ONLINE = "TXT_CARD_REALTIME_ONLINE";
export const TXT_CARD_TOTAL_MESSAGES = "TXT_CARD_TOTAL_MESSAGES";
export const TXT_CARD_ALL_TIME = "TXT_CARD_ALL_TIME";
export const TXT_CARD_MESSAGES_SENT = "TXT_CARD_MESSAGES_SENT";
export const TXT_CARD_DIRECT_MESSAGES = "TXT_CARD_DIRECT_MESSAGES";
export const TXT_CARD_GROUP_MESSAGES = "TXT_CARD_GROUP_MESSAGES";
export const TXT_CARD_LAST_UPDATED = "TXT_CARD_LAST_UPDATED";
export const TXT_CARD_REFRESH = "TXT_CARD_REFRESH";
export const TXT_CARD_AUTO_REFRESH = "TXT_CARD_AUTO_REFRESH";
export const TXT_CARD_REFRESH_OFF = "TXT_CARD_REFRESH_OFF";
export const TXT_CARD_ACTIVITY_STATUS = "TXT_CARD_ACTIVITY_STATUS";
export const TXT_CARD_ACTIVE = "TXT_CARD_ACTIVE";
export const TXT_CARD_FILES_STORAGE = "TXT_CARD_FILES_STORAGE";
export const TXT_CARD_UPLOADED_FILES = "TXT_CARD_UPLOADED_FILES";
export const TXT_CARD_TOTAL_FILES = "TXT_CARD_TOTAL_FILES";
export const TXT_CARD_STORAGE_USED = "TXT_CARD_STORAGE_USED";
export const TXT_CARD_USER_ENGAGEMENT = "TXT_CARD_USER_ENGAGEMENT";
export const TXT_CARD_DAU_DAILY = "TXT_CARD_DAU_DAILY";
export const TXT_CARD_WAU_WEEKLY = "TXT_CARD_WAU_WEEKLY";
export const TXT_CARD_MAU_MONTHLY = "TXT_CARD_MAU_MONTHLY";
export const TXT_CARD_CALLS_CONFERENCES = "TXT_CARD_CALLS_CONFERENCES";
export const TXT_CARD_CALLS_UNIT = "TXT_CARD_CALLS_UNIT";
export const TXT_CARD_DIRECT_CALLS = "TXT_CARD_DIRECT_CALLS";
export const TXT_CARD_CALL_SUCCESS = "TXT_CARD_CALL_SUCCESS";
export const TXT_CARD_CALL_MISSED = "TXT_CARD_CALL_MISSED";
export const TXT_CARD_GROUP_CALLS = "TXT_CARD_GROUP_CALLS";
export const TXT_CARD_GROUP_SESSIONS = "TXT_CARD_GROUP_SESSIONS";
export const TXT_CARD_CHANNELS_GROUPS = "TXT_CARD_CHANNELS_GROUPS";
export const TXT_CARD_CHANNELS_GROUPS_UNIT = "TXT_CARD_CHANNELS_GROUPS_UNIT";
export const TXT_CARD_CHANNELS_COUNT = "TXT_CARD_CHANNELS_COUNT";
export const TXT_CARD_GROUPS_COUNT = "TXT_CARD_GROUPS_COUNT";
export const TXT_CARD_PUBLIC = "TXT_CARD_PUBLIC";
export const TXT_CARD_PRIVATE = "TXT_CARD_PRIVATE";
export const TXT_CARD_DISCUSSION_GROUPS = "TXT_CARD_DISCUSSION_GROUPS";


// Statistic - SelectDateTime
export const TXT_DATE_TODAY = "TXT_DATE_TODAY";
export const TXT_DATE_LAST_7_DAYS = "TXT_DATE_LAST_7_DAYS";
export const TXT_DATE_LAST_1_MONTH = "TXT_DATE_LAST_1_MONTH";
export const TXT_DATE_LAST_3_MONTHS = "TXT_DATE_LAST_3_MONTHS";
export const TXT_DATE_BY_YEAR = "TXT_DATE_BY_YEAR";
export const TXT_DATE_CUSTOM = "TXT_DATE_CUSTOM";

// Statistic - Table headers
export const TXT_STATISTIC_COL_STT = "TXT_STATISTIC_COL_STT";
export const TXT_STATISTIC_COL_TYPE = "TXT_STATISTIC_COL_TYPE";
export const TXT_STATISTIC_COL_NAME = "TXT_STATISTIC_COL_NAME";
export const TXT_STATISTIC_COL_MEMBER_COUNT = "TXT_STATISTIC_COL_MEMBER_COUNT";
export const TXT_STATISTIC_COL_TOTAL_MESSAGES = "TXT_STATISTIC_COL_TOTAL_MESSAGES";
export const TXT_STATISTIC_COL_LAST_ACTIVE = "TXT_STATISTIC_COL_LAST_ACTIVE";

// MediaManagement
export const TXT_MEDIA_MESSAGE_LIST = "TXT_MEDIA_MESSAGE_LIST";
export const TXT_MEDIA_ACCOUNT_INFO = "TXT_MEDIA_ACCOUNT_INFO";
export const TXT_MEDIA_COMPOSE_NEW = "TXT_MEDIA_COMPOSE_NEW";
export const TXT_MEDIA_COMPOSE = "TXT_MEDIA_COMPOSE";
export const TXT_MEDIA_SCHEDULE_SEND = "TXT_MEDIA_SCHEDULE_SEND";
export const TXT_MEDIA_SCHEDULE_BTN = "TXT_MEDIA_SCHEDULE_BTN";
export const TXT_MEDIA_SEND = "TXT_MEDIA_SEND";
export const TXT_MEDIA_SAVE_DRAFT = "TXT_MEDIA_SAVE_DRAFT";
export const TXT_MEDIA_SAVE_DRAFT_TITLE = "TXT_MEDIA_SAVE_DRAFT_TITLE";
export const TXT_MEDIA_SAVE_DRAFT_CONTENT = "TXT_MEDIA_SAVE_DRAFT_CONTENT";
export const TXT_MEDIA_SAVE_DRAFT_BTN = "TXT_MEDIA_SAVE_DRAFT_BTN";
export const TXT_MEDIA_EXIT = "TXT_MEDIA_EXIT";
export const TXT_MEDIA_INPUT_PLACEHOLDER = "TXT_MEDIA_INPUT_PLACEHOLDER";
export const TXT_MEDIA_MAX_CHARS_ERROR = "TXT_MEDIA_MAX_CHARS_ERROR";
export const TXT_MEDIA_CONTENT_EXCEEDS = "TXT_MEDIA_CONTENT_EXCEEDS";
export const TXT_MEDIA_CONTENT_EMPTY = "TXT_MEDIA_CONTENT_EMPTY";
export const TXT_MEDIA_SEND_SUCCESS = "TXT_MEDIA_SEND_SUCCESS";
export const TXT_MEDIA_SCHEDULE_SUCCESS = "TXT_MEDIA_SCHEDULE_SUCCESS";
export const TXT_MEDIA_DRAFT_SAVED = "TXT_MEDIA_DRAFT_SAVED";
export const TXT_MEDIA_CANCEL_SCHEDULE = "TXT_MEDIA_CANCEL_SCHEDULE";
export const TXT_MEDIA_DELETED = "TXT_MEDIA_DELETED";
export const TXT_MEDIA_RESEND = "TXT_MEDIA_RESEND";
export const TXT_MEDIA_CONTINUE = "TXT_MEDIA_CONTINUE";
export const TXT_MEDIA_CONFIRM_DELETE_TITLE = "TXT_MEDIA_CONFIRM_DELETE_TITLE";
export const TXT_MEDIA_CONFIRM_DELETE_CONTENT = "TXT_MEDIA_CONFIRM_DELETE_CONTENT";
export const TXT_MEDIA_CONFIRM_CANCEL_TITLE = "TXT_MEDIA_CONFIRM_CANCEL_TITLE";
export const TXT_MEDIA_CONFIRM_CANCEL_CONTENT = "TXT_MEDIA_CONFIRM_CANCEL_CONTENT";
export const TXT_MEDIA_CONFIRM_BTN = "TXT_MEDIA_CONFIRM_BTN";
export const TXT_MEDIA_COL_MESSAGE = "TXT_MEDIA_COL_MESSAGE";
export const TXT_MEDIA_COL_STATUS = "TXT_MEDIA_COL_STATUS";
export const TXT_MEDIA_COL_TIME = "TXT_MEDIA_COL_TIME";
export const TXT_MEDIA_COL_ACTION = "TXT_MEDIA_COL_ACTION";
export const TXT_MEDIA_STATISTIC_TITLE = "TXT_MEDIA_STATISTIC_TITLE";
export const TXT_MEDIA_TOTAL_SENT = "TXT_MEDIA_TOTAL_SENT";
export const TXT_MEDIA_SEND_SUCCESS_RATE = "TXT_MEDIA_SEND_SUCCESS_RATE";
export const TXT_MEDIA_TOTAL_RECEIVED = "TXT_MEDIA_TOTAL_RECEIVED";
export const TXT_MEDIA_RECEIVE_SUCCESS_RATE = "TXT_MEDIA_RECEIVE_SUCCESS_RATE";
export const TXT_MEDIA_TOTAL_READ = "TXT_MEDIA_TOTAL_READ";
export const TXT_MEDIA_READ_RATE = "TXT_MEDIA_READ_RATE";

// BotAccountDialog
export const TXT_MEDIA_ACCOUNT_NAME = "TXT_MEDIA_ACCOUNT_NAME";
export const TXT_MEDIA_ACCOUNT_NAME_PLACEHOLDER = "TXT_MEDIA_ACCOUNT_NAME_PLACEHOLDER";
export const TXT_MEDIA_DESCRIPTION = "TXT_MEDIA_DESCRIPTION";
export const TXT_MEDIA_UPLOAD_AVATAR = "TXT_MEDIA_UPLOAD_AVATAR";

// System const labels
export const TXT_BRANCH_STATUS_ALL = "TXT_BRANCH_STATUS_ALL";
export const TXT_BRANCH_STATUS_PENDING = "TXT_BRANCH_STATUS_PENDING";
export const TXT_BRANCH_STATUS_ACCEPTED = "TXT_BRANCH_STATUS_ACCEPTED";
export const TXT_BRANCH_STATUS_REJECTED = "TXT_BRANCH_STATUS_REJECTED";
export const TXT_BOT_STATUS_PENDING = "TXT_BOT_STATUS_PENDING";
export const TXT_BOT_STATUS_SUCCESS = "TXT_BOT_STATUS_SUCCESS";
export const TXT_BOT_STATUS_CANCELED = "TXT_BOT_STATUS_CANCELED";
export const TXT_BOT_STATUS_DRAFT = "TXT_BOT_STATUS_DRAFT";
export const TXT_BOT_STATUS_FAILED = "TXT_BOT_STATUS_FAILED";
export const TXT_GROUP_TYPE_INBOX = "TXT_GROUP_TYPE_INBOX";
export const TXT_GROUP_TYPE_GROUP = "TXT_GROUP_TYPE_GROUP";
export const TXT_GROUP_TYPE_CHANNEL = "TXT_GROUP_TYPE_CHANNEL";

// ConferenceManagement filters
export const TXT_FILTER_ALL = "TXT_FILTER_ALL";
export const TXT_FILTER_OTHER = "TXT_FILTER_OTHER";

// UserRequestManagement
export const TXT_REQUEST_CONFIRM_REMOVE_REJECT = "TXT_REQUEST_CONFIRM_REMOVE_REJECT";
export const TXT_REQUEST_CONFIRM_REMOVE_REJECT_CONTENT = "TXT_REQUEST_CONFIRM_REMOVE_REJECT_CONTENT";
export const TXT_REQUEST_REJECT_TITLE = "TXT_REQUEST_REJECT_TITLE";
export const TXT_REQUEST_REJECT_CONTENT = "TXT_REQUEST_REJECT_CONTENT";

// UserManagement tabs
export const TXT_TAB_USER_LIST = "TXT_TAB_USER_LIST";
export const TXT_TAB_PENDING_LIST = "TXT_TAB_PENDING_LIST";
export const TXT_TAB_REJECTED_LIST = "TXT_TAB_REJECTED_LIST";
export const TXT_TOTAL_USERS_COUNT = "TXT_TOTAL_USERS_COUNT";

// Settings - Theme
export const TXT_THEME_CONFIG = "TXT_THEME_CONFIG";
export const TXT_THEME_LIGHT = "TXT_THEME_LIGHT";
export const TXT_THEME_DARK = "TXT_THEME_DARK";
export const TXT_THEME_SYSTEM = "TXT_THEME_SYSTEM";

// ConferenceManagement
export const TXT_APP_LIST = "TXT_APP_LIST";
export const TXT_ADMIN_LIST = "TXT_ADMIN_LIST";
export const TXT_USER_LIST_LABEL = "TXT_USER_LIST_LABEL";
export const TXT_REMOVE_MEMBER = "TXT_REMOVE_MEMBER";
export const TXT_APP_CONFIG_DESC = "TXT_APP_CONFIG_DESC";
export const TXT_APP_TITLE_SECTION = "TXT_APP_TITLE_SECTION";
export const TXT_TITLE_REQUIRED = "TXT_TITLE_REQUIRED";
export const TXT_SUBTITLE = "TXT_SUBTITLE";

// SystemTracking
export const TXT_SEARCH_BUTTON = "TXT_SEARCH_BUTTON";

// Settings - ServerInformation
export const TXT_SERVER_INFO = "TXT_SERVER_INFO";
export const TXT_CONTENT = "TXT_CONTENT";
export const TXT_PREVIEW = "TXT_PREVIEW";
export const TXT_QR_SERVER = "TXT_QR_SERVER";
export const TXT_CREATE_QR = "TXT_CREATE_QR";
export const TXT_SAVE_QR = "TXT_SAVE_QR";
export const TXT_IMAGE_TOO_LARGE = "TXT_IMAGE_TOO_LARGE";
export const TXT_QR_EXPIRED = "TXT_QR_EXPIRED";
export const TXT_QR_VALID_UNTIL = "TXT_QR_VALID_UNTIL";

// Default language code
export const DEFAULT_LANGUAGE = "vi";

// Namespace Key
export const NS_COMMON = "common";
export const NS_LOGIN = "login";
export const NS_DEVICE_MANAGEMENT = "deviceManagement";

// Common languages
export const ARR_LANGUAGES = [
  { lang: "Tiếng Việt", code: "vi", label: L_VIETNAMESE_LANGUAGE },
  { lang: "English", code: "en", label: L_ENGLISH_LANGUAGE },
];

// Dùng cho cả channel
export const BRANCH_MODE = [
  { label: L_PUBLIC_MODE, code: 0 },
  { label: L_PRIVATE_MODE, code: 1 },
];

export const LOGIN_MODE = [
  { label: L_OTP_MODE, code: 0 },
  { label: L_PASSWORD_MODE, code: 1 },
];
